module.exports = __webpack_public_path__ + "img/how-to-verify-a-credit-card-with-free-api.ff454e34.jpg";